import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { formatClassName } from '../utils';

/** renders a banner at the bottom of the page header */
export class PageBanner extends Component {
  static propTypes = {
    /** children are rendered inside of the page banner */
    children: PropTypes.any,
    /** adds the className to the banner wrapper */
    className: PropTypes.string,
  };

  render() {
    const { className } = this.props;
    const bannerClassName = formatClassName(['page-banner', className]);

    return <div className={bannerClassName}>{this.props.children}</div>;
  }
}
